import { Heading, Card, Inline, Stack, breakpoints } from '@etg/wings';
import { css, mediaQueries } from '@eti/styles';
import { useMediaQuery } from 'usehooks-ts';
import { extractSegmentData } from '../utils/utils';
import { CABIN_UPGRADE } from '../../products';
import { OriginDestinationText } from './OriginDestinationText';
import CabinUpgradeAvailabilityStatus from './CabinUpgradeAvailabilityStatus';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const availabiltyCardStyles = css`
  border: solid #e5e5e5 1px;
`;
const availabiltyListStyles = css`
  padding: 16px 8px 0;
`;
const availabiltyListItemStyles = css`
  align-items: center;
  display: flex;
  justify-content: space-between;

  @media ${mediaQueries.small.only} {
    align-items: flex-start;
    flex-direction: column;
  }
`;
const CabinUpgradeAvailabilityCard = _ref => {
  var _availabilityTexts$av;
  let {
    availabilityTexts,
    segmentUpgradeList
  } = _ref;
  const isDesktopView = useMediaQuery(`(min-width: ${breakpoints._768})`);
  return /*#__PURE__*/_jsxs(Card, {
    className: availabiltyCardStyles,
    "data-testid": `${CABIN_UPGRADE.name}-availability-card`,
    children: [/*#__PURE__*/_jsx(Heading, {
      level: 4,
      children: availabilityTexts === null || availabilityTexts === void 0 || (_availabilityTexts$av = availabilityTexts.availabilityCard) === null || _availabilityTexts$av === void 0 ? void 0 : _availabilityTexts$av.availabilityTitle
    }), /*#__PURE__*/_jsx(Stack, {
      className: availabiltyListStyles,
      role: "list",
      spacing: isDesktopView ? 16 : 24,
      children: segmentUpgradeList.map((segmentUpgrade, index) => {
        const {
          isSegmentAvailable,
          flightRoute,
          originDestinationAirportAriaLabelText,
          segmentIndex
        } = extractSegmentData(segmentUpgrade, availabilityTexts);
        return /*#__PURE__*/_jsxs(Inline, {
          "aria-label": originDestinationAirportAriaLabelText,
          className: availabiltyListItemStyles,
          role: "listitem",
          spacing: 0,
          children: [/*#__PURE__*/_jsx(Inline, {
            "data-testid": `${CABIN_UPGRADE.name}-availability-card-bound-${segmentUpgrade.boundIndex}-segment-${segmentIndex}-trip-route`,
            spacing: 4,
            children: /*#__PURE__*/_jsx(OriginDestinationText, {
              flightRoute: flightRoute
            })
          }), /*#__PURE__*/_jsx(CabinUpgradeAvailabilityStatus, {
            availabilityCardTexts: availabilityTexts === null || availabilityTexts === void 0 ? void 0 : availabilityTexts.availabilityCard,
            "data-testid": `${CABIN_UPGRADE.name}-availability-card-bound-${segmentUpgrade.boundIndex}-segment-${segmentIndex}-availability-status`,
            isSegmentAvailable: isSegmentAvailable,
            originDestinationAirportAriaLabelText: originDestinationAirportAriaLabelText
          })]
        }, index);
      })
    })]
  });
};
export default CabinUpgradeAvailabilityCard;
//# sourceMappingURL=CabinUpgradeAvailabilityCard.js.map